module.exports = __webpack_public_path__ + "editor/icon-cart-64441b94859deeed326d425f0f526d8c.svg";